import styled from 'styled-components';

const Root = styled.form `
  display: flex;
  flex-direction: column;
  gap: ${props => `${props.$gap}px`};
`;

export { Root };
